var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticStyle: { "margin-bottom": "40px" },
          attrs: { "align-h": "center" }
        },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "9" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-5" },
                [
                  _c("b-col", { staticClass: "mb-3", attrs: { cols: "12" } }, [
                    _c("h2", { staticClass: "text-left mb-3" }, [
                      _vm._v("Ongoing Missions")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataOnGoingHome, function(donat) {
                    return _c(
                      "b-col",
                      {
                        key: donat.id,
                        staticClass: "mb-4",
                        attrs: { cols: "12", xl: "6" }
                      },
                      [
                        _c("div", { staticClass: "donatee d-flex" }, [
                          _c("img", { attrs: { src: donat.image } }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "donatee-info d-flex flex-column ml-3 ml-sm-4 pt-4 pt-sm-5 w-100 align-items-start"
                            },
                            [
                              _c(
                                "h2",
                                { staticClass: "mb-2 text-left donatee-name" },
                                [_vm._v(_vm._s(donat.name))]
                              ),
                              _vm._v(" "),
                              donat.subscribed
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column text-left subscribed"
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "d-inline-block mb-1" },
                                        [
                                          _vm._v(
                                            "Next Donation Period " +
                                              _vm._s(donat.next_donation)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "cursor-pointer text-dark",
                                          on: {
                                            click: function($event) {
                                              return _vm.cancelDonation(
                                                donat.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Cancel Donation")]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !donat.subscribed
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        href: "/#/donations?_d=" + donat.id
                                      }
                                    },
                                    [_vm._v("Donate Now")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-5" },
                [
                  _c("b-col", [
                    _c("h2", { staticClass: "text-left mb-3" }, [
                      _vm._v("My Dashboard")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "user-info d-flex flex-column flex-md-row"
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "d-flex user-info-1",
                            attrs: { cols: "12", md: "6" }
                          },
                          [
                            _c("img", {
                              staticClass: "rounded-circle my-auto mr-3",
                              attrs: {
                                src: !!_vm.userProfile.avatar
                                  ? _vm.userProfile.avatar
                                  : _vm.defaultLogo,
                                width: "72",
                                height: "72"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "user-info-content" }, [
                              _c(
                                "div",
                                { staticClass: "user-name text-left" },
                                [_vm._v(_vm._s(_vm.userProfile.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-email text-left" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.userProfile.email) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-date text-left" },
                                [
                                  !!_vm.userProfile
                                    ? [
                                        _vm.userProfile.type === 0
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.userProfile.joined)
                                              )
                                            ])
                                          : _vm.isMonthlySubscriber
                                          ? _c("span", [
                                              _vm._v(
                                                "Next Billing Period:\n                      " +
                                                  _vm._s(
                                                    _vm.moment(
                                                      _vm.userProfile
                                                        .subscription.end_date
                                                    )
                                                  )
                                              )
                                            ])
                                          : !_vm.isMonthlySubscriber
                                          ? _c("span", [
                                              _vm._v(
                                                "Premium Ends On:\n                      " +
                                                  _vm._s(
                                                    _vm.moment(
                                                      _vm.userProfile
                                                        .subscription.end_date
                                                    )
                                                  )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "user-date text-left" },
                                [
                                  _vm.isMonthlySubscriber
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "cursor-pointer text-dark",
                                          on: {
                                            click: _vm.toggleManageSubscription
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Manage Membership"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "d-flex user-info-2 justify-content-between justify-content-md-end",
                            attrs: { cols: "12", md: "6" }
                          },
                          [
                            _vm.userProfile.type === 0 &&
                            _vm.paymentPendingStatus === ""
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-auto mr-5 text-center user-info-link"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mb-2 label-btn-info-1" },
                                      [_vm._v("Listen to Songs in Full")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          to: "/subscription"
                                        }
                                      },
                                      [_vm._v("Join")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "my-auto text-center user-info-link"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "mb-2 label-btn-info-2" },
                                  [
                                    _vm._v(
                                      "Credit " +
                                        _vm._s(_vm.userProfile.credit_balance)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary", to: "/top-up" }
                                  },
                                  [_vm._v("Top Up")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("h2", { staticClass: "text-left mb-3" }, [
                        _vm._v("Transaction History")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-tabs",
                        {
                          attrs: {
                            pills: "",
                            "active-nav-item-class": "custom-active-nav"
                          }
                        },
                        [
                          _c(
                            "b-tab",
                            { attrs: { title: "Credit Purchase", active: "" } },
                            [
                              _c("div", { staticClass: "w-100 mt-4" }),
                              _vm._v(" "),
                              _c("b-table", {
                                staticClass: "rounded",
                                attrs: {
                                  id: "my-table",
                                  busy: _vm.isBusy,
                                  items: _vm.fetchData,
                                  fields: _vm.fields,
                                  bordered: true,
                                  "per-page": _vm.filter.per_page,
                                  "current-page": _vm.filter.page,
                                  "head-variant": "light",
                                  hover: true,
                                  responsive: ""
                                },
                                on: {
                                  "update:busy": function($event) {
                                    _vm.isBusy = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "head()",
                                    fn: function(data) {
                                      return [
                                        _c("span", [_vm._v(_vm._s(data.label))])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("b-pagination", {
                                attrs: {
                                  "total-rows": _vm.total,
                                  "per-page": _vm.filter.per_page,
                                  "aria-controls": "my-table"
                                },
                                model: {
                                  value: _vm.filter.page,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "page", $$v)
                                  },
                                  expression: "filter.page"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            { attrs: { title: "Content Purchase" } },
                            [
                              _c("div", { staticClass: "w-100 mt-4" }),
                              _vm._v(" "),
                              _c("b-table", {
                                staticClass: "rounded",
                                attrs: {
                                  id: "my-table2",
                                  bordered: true,
                                  items: _vm.fetchDataContent,
                                  fields: _vm.fieldsContent,
                                  "per-page": _vm.filterContent.per_page,
                                  "current-page": _vm.filterContent.page,
                                  "head-variant": "light",
                                  hover: true,
                                  responsive: ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(actions)",
                                    fn: function(row) {
                                      return [
                                        row.item.type === "song"
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.download(
                                                      row.item.item_id,
                                                      row.item.artist_name +
                                                        " - " +
                                                        row.item.product_name
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Download\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        row.item.type === "album"
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: { click: row.toggleDetails }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    See Songs\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  },
                                  {
                                    key: "row-details",
                                    fn: function(row) {
                                      return [
                                        _c(
                                          "b-card",
                                          [
                                            _c(
                                              "b-list-group",
                                              _vm._l(row.item.songs, function(
                                                song
                                              ) {
                                                return _c(
                                                  "b-list-group-item",
                                                  {
                                                    key: song.id,
                                                    staticClass:
                                                      "d-flex justify-content-between align-items-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(song.title) +
                                                        "\n                        "
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "javascript:void(0)"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.download(
                                                              song.id,
                                                              row.item
                                                                .artist_name +
                                                                " - " +
                                                                song.title
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("Download")]
                                                    )
                                                  ]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("b-pagination", {
                                attrs: {
                                  "total-rows": _vm.totalContent,
                                  "per-page": _vm.filterContent.per_page,
                                  "aria-controls": "my-table2"
                                },
                                model: {
                                  value: _vm.filterContent.page,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filterContent, "page", $$v)
                                  },
                                  expression: "filterContent.page"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            { attrs: { title: "Donations" } },
                            [
                              _c("div", { staticClass: "w-100 mt-4" }),
                              _vm._v(" "),
                              _c("b-table", {
                                staticClass: "rounded",
                                attrs: {
                                  id: "my-table3",
                                  bordered: true,
                                  busy: _vm.isBusyDonation,
                                  items: _vm.fetchDataDonation,
                                  fields: _vm.fieldsDonations,
                                  "per-page": _vm.filterDonations.per_page,
                                  "current-page": _vm.filterDonations.page,
                                  "head-variant": "light",
                                  hover: true,
                                  responsive: ""
                                },
                                on: {
                                  "update:busy": function($event) {
                                    _vm.isBusyDonation = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "head()",
                                    fn: function(data) {
                                      return [
                                        _c("span", [_vm._v(_vm._s(data.label))])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("b-pagination", {
                                attrs: {
                                  "total-rows": _vm.totalDonations,
                                  "per-page": _vm.filterDonations.per_page,
                                  "aria-controls": "my-table3"
                                },
                                model: {
                                  value: _vm.filterDonations.page,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filterDonations, "page", $$v)
                                  },
                                  expression: "filterDonations.page"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            { attrs: { title: "Download Receipt" } },
                            [
                              _c("div", { staticClass: "w-100 mt-4" }),
                              _vm._v(" "),
                              _c("b-table", {
                                staticClass: "rounded",
                                attrs: {
                                  id: "my-table4",
                                  bordered: true,
                                  busy: _vm.isBusyReceipt,
                                  items: _vm.fetchDataReceipt,
                                  fields: _vm.fieldsReceipts,
                                  "per-page": _vm.filterReceipts.per_page,
                                  "current-page": _vm.filterReceipts.page,
                                  "head-variant": "light",
                                  hover: true,
                                  responsive: ""
                                },
                                on: {
                                  "update:busy": function($event) {
                                    _vm.isBusyReceipt = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "head()",
                                    fn: function(data) {
                                      return [
                                        _c("span", [_vm._v(_vm._s(data.label))])
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(actions)",
                                    fn: function(row) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.downloadReceipt(
                                                  row.item.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Download Receipt\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("b-pagination", {
                                attrs: {
                                  "total-rows": _vm.totalReceipts,
                                  "per-page": _vm.filterReceipts.per_page,
                                  "aria-controls": "my-table4"
                                },
                                model: {
                                  value: _vm.filterReceipts.page,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filterReceipts, "page", $$v)
                                  },
                                  expression: "filterReceipts.page"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-tab",
                            { attrs: { title: "Subscription Receipt" } },
                            [
                              _c("div", { staticClass: "w-100 mt-4" }),
                              _vm._v(" "),
                              _c("b-table", {
                                staticClass: "rounded",
                                attrs: {
                                  id: "my-table5",
                                  bordered: true,
                                  busy: _vm.isBusySubscriptionReceipt,
                                  items: _vm.fetchDataSubscriptionReceipt,
                                  fields: _vm.fieldsSubscriptionReceipts,
                                  "per-page":
                                    _vm.filterSubscriptionReceipts.per_page,
                                  "current-page":
                                    _vm.filterSubscriptionReceipts.page,
                                  "head-variant": "light",
                                  hover: true,
                                  responsive: ""
                                },
                                on: {
                                  "update:busy": function($event) {
                                    _vm.isBusySubscriptionReceipt = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "head()",
                                    fn: function(data) {
                                      return [
                                        _c("span", [_vm._v(_vm._s(data.label))])
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(actions)",
                                    fn: function(row) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.downloadSubscriptionReceipt(
                                                  row.item.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Download Receipt\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("b-pagination", {
                                attrs: {
                                  "total-rows": _vm.totalSubscriptionReceipts,
                                  "per-page":
                                    _vm.filterSubscriptionReceipts.per_page,
                                  "aria-controls": "my-table5"
                                },
                                model: {
                                  value: _vm.filterSubscriptionReceipts.page,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filterSubscriptionReceipts,
                                      "page",
                                      $$v
                                    )
                                  },
                                  expression: "filterSubscriptionReceipts.page"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fae5bece", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fae5bece","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 